import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';

export type Status = 'hidden' | 'disabled' | 'enabled';

export interface SubSection {
  label: string;
  icon: string;
  route: string;
  status: Status;
}

export interface Section {
  title: string;
  subtitle?: string;
  icon: string;
  color: string;
  route?: string;
  subSections?: SubSection[];
  status: Status;
  order: number;
}


@Injectable({
  providedIn: 'root',
})
export class SectionService {
  private http = inject(HttpClient);
  private secciones$: Observable<Section[]> | null = null;
  constructor() { }

  getSections(): Observable<Section[]> {
    if (this.secciones$) {
      return this.secciones$;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    this.secciones$ = this.http
      .get<Section[]>('sections', { headers })
      .pipe(
        shareReplay(1)
      );

    return this.secciones$;
  }

}
